<template>
    <v-hover v-slot="{ hover }">
        <v-card
            :elevation="hover ? 6 : 1"
            class="task_list_item"
            @click="redirect(task.taskId)"
        >
            <v-row>
                <v-col cols="2" class=" d-flex align-center justify-center">
                    <p class="roma-card__pre-title">
                        <!-- {{ task.section }} -->
                        {{ task.lessonTO.section.nameAndCategoryName }}
                    </p>

                    <p class="roma-card__pre-title pl-1">
                        {{ task.lessonTO.subject.abbreviation }}
                    </p>

                    <p class="roma-card__pre-title pl-1">
                        {{ task.lessonTO.unit.abbreviation }}
                    </p>
                </v-col>
                <v-col class="col-4">
                    <span
                        class="cardTitle--text font-weight-regular"
                    >
                        {{ task.lessonTO.title }}
                    </span>
                    -
                     <span
                        class="cardTitle--text font-weight-regular"
                    >
                        {{ task.activityTO.title }}
                    </span>
                </v-col>
                <v-col class=" d-flex col-2 ">
                    <p class="text-capitalize">
                        {{ task.student.fullName.toLowerCase()}}
                    </p>
                    
                </v-col>
                <v-col class="d-flex justify-left col-2">

                    <span v-if="!!task.taskCheckedDate" class="roma-card__pre-title mx-3">
                       {{ formatDate(task.taskCheckedDate) }}
                    </span>
                    <span v-if="!!task.score && (!task.achievement || task.achievement === 0)" style="color: #0000FF" class="roma-card__header">
                       Nota: {{ task.score }}
                    </span>
                    <span v-if="!!task.achievement && (!task.score || task.score===0)" style="color: #0000FF" class="roma-card__header">
                       Logro: {{ task.achievement }}%
                    </span>
                    <span v-if="!!task.score && !!task.achievement && task.score>0 && task.achievement>0" style="color: #0000FF" class="roma-card__header">
                       Nota: {{ task.score }} / {{ task.achievement }}%
                    </span>
                </v-col>
                <v-col class="d-flex justify-center col-2">

                    <span v-if="task.state == 0" style="color: #FF7B20">Por Evaluar</span>
                    <span v-else-if="task.state == 1" style="color: #3bd679">Evaluado</span>
                    <span v-else style="color: #FF0000" >Por Recibir</span>

                </v-col>
            </v-row>
        </v-card>
    </v-hover>
</template>

<script>
import moment from 'moment'
export default {
    props: {
        task: {
            required: true,
            type: Object
        }
    },

    methods: {
        redirect(taskId) {

            if(!taskId){
                return;
            }

            this.$router.push({
                name: "TaskDetail",
                params: { id: taskId }
            });
        },
        formatDate(date) {
            return moment(date).format("DD / MM");
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/main";
.task_list_item {
    margin-top: 0.5rem;
    width: 100%;
    padding-bottom: 0%;
    background: #ffffff;
    border-radius: 5px;
    //   padding: 1rem;
    // box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    //     0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}

.roma-card__pre-title,
.roma-card__header {
    font-size: 14px;
}
</style>
